import './style.css'

import ReactDOM from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { Leva } from 'leva'
import App from './app'

// Check if dev mode is enabled via URL parameter
const isDevMode = new URLSearchParams(window.location.search).get('dev') === 'true'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
  <>
    <Leva hidden={!isDevMode} />
    <App />
    <Analytics/>
  </>
)


